import { URLSearchParams } from 'url'
import { $http, RequestData, RequestHeaders, route, RouteName, RouteParams, URLParams, urlParams } from '@/munio/http'

export class Api<P = RouteParams<any>> {
  constructor(public readonly params: P = {} as P) {}

  protected get $http() {
    return $http
  }

  protected $query(params: URLParams = window.location.search): URLSearchParams {
    return urlParams(params)
  }

  protected $route<R extends RouteName>(name: R, params?: Omit<RouteParams<R>, keyof P>): string {
    return route(name, { ...this.params, ...(params || {}) } as RouteParams<R>)
  }

  protected $get<T>(url: string, data?: RequestData, headers?: RequestHeaders, config?: object) {
    return this.$http.get<T>(url, data, headers, config)
  }

  protected $post<T>(url: string, data?: RequestData, headers?: RequestHeaders, config?: object) {
    return this.$http.post<T>(url, data, headers, config)
  }

  protected $put<T>(url: string, data?: RequestData, headers?: RequestHeaders, config?: object) {
    return this.$http.put<T>(url, data, headers, config)
  }

  protected $patch<T>(url: string, data?: RequestData, headers?: RequestHeaders, config?: object) {
    return this.$http.patch<T>(url, data, headers, config)
  }

  protected $delete<T>(url: string, data?: RequestData, headers?: RequestHeaders, config?: object) {
    return this.$http.delete<T>(url, data, headers, config)
  }

  protected $beacon(url: string, data?: RequestData) {
    return this.$http.beacon(url, data)
  }

  protected $sse(url: string, events: Record<string, Function>) {
    return this.$http.sse(url, events)
  }
}
